// extracted by mini-css-extract-plugin
export default {"MothersDayFlowers":"MothersDayFlowers_MothersDayFlowers__3fnpC","MothersDayFlowers_hidden":"MothersDayFlowers_MothersDayFlowers_hidden__XCAx9"};